import React from 'react'
import ApiUrl from '../../../../configTools/apiUrl';
import Button from '../../../../components/forms/blackfillButton';
import LightButton from '../../../../components/forms/lightfillButton';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import FeedItem from '../../../../components/public/pages/home/feedItem';
import { useState,useEffect } from 'react';

const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [feeds, setFeeds] = useState([]);
    const [feedpage, setFeedPage] = useState(0);
    const [feedHasMore, setFeedHasMore] = useState(true);

    const refresh_Feeds = async ()=>{
        var newpage = 0
        let finalfeeds = [];
        while (newpage <= feedpage) {
            var data = await fetch(ApiUrl.API_URL_Feeds+"/"+newpage,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+User.token
                }
            })
            data = await data.json();
            for (let index = 0; index < data.responce.length; index++) {
            const element = data.responce[index];
            finalfeeds.push(element);
            }
            newpage++;
        }
        setFeeds(finalfeeds);
    }
    const getmore_Feeds = ()=>{
        fetch(ApiUrl.API_URL_Feeds+"/"+feedpage,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
        let prevfeeds = feeds;
        for (let index = 0; index < data.responce.length; index++) {
            const element = data.responce[index];
            prevfeeds.push(element);
        }
        setFeeds(prevfeeds);
        setFeedPage(feedpage+1);
        if(data.responce.length === 0){
            setFeedHasMore(false);
        }
        });
    }

    useEffect(() => {
    if(User !== null){
        fetch(ApiUrl.API_URL_Feeds+"/"+feedpage,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
        setFeeds(data.responce);
        setFeedPage(feedpage+1);
        if(data.responce.length === 0){
            setFeedHasMore(false);
        }
        });
    }
    },[])
  return (
    <>
        {User &&
            <InfiniteScroll 
                dataLength={feeds.length}
                next={getmore_Feeds}
                hasMore={feedHasMore}
                loader={<h1></h1>}
            >
                <div className='public_home_feed_container'>
                    {
                        feeds.map((feed,index)=>{
                            return(
                                <FeedItem Item={feed} key={index} refreshFeeds={refresh_Feeds}/>
                            )
                        })
                    }
                </div>
            </InfiniteScroll>
        }
        {User === null &&
            <div className='public_home_feed_signIn'>
                <Link to='/login'><Button Value='Login'/></Link>
                <p className='login_or_text'>OR</p>
                <Link to='/signup'><LightButton Value='Signup'/></Link>
            </div>
        }
    </>
  )
}

export default Index
